import { c as _c } from "react/compiler-runtime";
import { ReactElement, memo, useLayoutEffect, useRef } from 'react';
import ConfigurableCmsValidity from '@spa/top-level-components/cms-page/metadata/configurable/configurable-cms-validity.component';
import removeScripts from './removeScripts';
import styles from './code.component.module.scss';
import useRuntimeSearchParams from '@spa/lib/react/hooks/useRuntimeSearchParams';
export interface Props {
  readonly componentId: string;
  readonly contentHtml: string;
  readonly editorMode: boolean;
  readonly dateFrom: number | null;
  readonly dateTo: number | null;
}
function CodeComponent(t0) {
  const $ = _c(23);
  const {
    contentHtml,
    componentId,
    dateTo,
    dateFrom,
    editorMode
  } = t0;
  const elRef = useRef(null);
  const searchParams = useRuntimeSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.get("redirected");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isRedirected = t1 === "true";
  let t2;
  if ($[2] !== contentHtml) {
    t2 = removeScripts(contentHtml);
    $[2] = contentHtml;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const staticHtml = t2;
  let t3;
  let t4;
  if ($[4] !== contentHtml || $[5] !== isRedirected || $[6] !== staticHtml) {
    t3 = () => {
      const el = elRef.current;
      let restoreTracking;
      if (el) {
        if (staticHtml !== contentHtml) {
          const range = document.createRange();
          range.selectNode(el);
          el.replaceChildren(range.createContextualFragment(contentHtml));
        }
        if (isRedirected) {
          const anchors = Array.from(el.querySelectorAll("a"));
          const originalTrackIds = anchors.map(_temp);
          anchors.forEach(_temp2);
          restoreTracking = () => {
            anchors.forEach((anchor_1, index) => {
              const originalTrackId = originalTrackIds[index];
              if (originalTrackId === null) {
                anchor_1.removeAttribute("data-track-id");
              } else {
                anchor_1.setAttribute("data-track-id", originalTrackId);
              }
            });
          };
        }
      }
      return restoreTracking;
    };
    t4 = [contentHtml, staticHtml, isRedirected];
    $[4] = contentHtml;
    $[5] = isRedirected;
    $[6] = staticHtml;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useLayoutEffect(t3, t4);
  let t5;
  if ($[9] !== dateFrom || $[10] !== dateTo || $[11] !== editorMode) {
    t5 = editorMode && <ConfigurableCmsValidity dateFrom={dateFrom} dateTo={dateTo} />;
    $[9] = dateFrom;
    $[10] = dateTo;
    $[11] = editorMode;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <>{t5}</>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== staticHtml) {
    t7 = {
      __html: staticHtml
    };
    $[15] = staticHtml;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== componentId || $[18] !== t7) {
    t8 = <div ref={elRef} id={componentId} className={styles["code-component"]} dangerouslySetInnerHTML={t7} />;
    $[17] = componentId;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t8) {
    t9 = <>{t6}{t8}</>;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}
function _temp2(anchor_0) {
  return anchor_0.setAttribute("data-track-id", "redirectSubSelector");
}
function _temp(anchor) {
  return anchor.getAttribute("data-track-id");
}
export default memo(CodeComponent);